import { Component, HostListener, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MemberService } from '../../core/services/member.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FeedService } from '../../core/services/feed.service';
import { EventService } from '../../core/services/event.service';
import {AuthService} from "../../core/services/auth.service";

@Component({
  selector: 'app-member-view',
  templateUrl: './member-view.component.html',
  styleUrls: ['./member-view.component.scss'],
})
export class MemberViewComponent implements OnInit {
  breadcrumbs: any[] = [];

  user = {
    name: 'William De Silva',
    email: 'Megan@info.com',
    mobileNo: '0770521051',
    phoneNo: '0770521051',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ' +
      'ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut\n' +
      '          aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore\n' +
      '          eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt\n' +
      '          mollit anim id est laborum.',
    position: 'Supreme Court Judge',
    residence: 'Supreme Court Kandy',
    workplace: 'Colombo',
  };
  member: {
    id: string;
    name: string;
    email: string;
    status: string;
    regCode: string;
    mobileNo: string;
    description: string;
    grade: string;
    profilePicture: { url: string } | null;
    position: string;
    residence: string;
    workplace: string;
    phoneNo: string;
  } = {
    id: '',
    name: '',
    email: '',
    status: '',
    regCode: '',
    mobileNo: '',
    description: '',
    grade: '',
    profilePicture: null,
    position: '',
    residence: '',
    workplace: '',
    phoneNo: '',
  };

  feed = [
    {
      title: 'new show',
      content: 'test',
      media: { url: 'test', mimeType: '', filename: '' },
      createdAt: '2023-09-27T01:18:02.484Z',
    },
  ];

  showFullTextPost = false;
  showFullText = false;
  mediaHeight = 300;
  wordCap = 250;
  avatarSize = 150;
  isExpanded: boolean[] = [];
  acceptedEvents: any[] = [];
  rejectedEvents: any[] = [];

  constructor(
    private authService: AuthService,
    private datePipe: DatePipe,
    private memberService: MemberService,
    private activatedRoute: ActivatedRoute,
    private feedService: FeedService,
    private router: Router,
    private eventsService: EventService,
  ) {
    this.setScreenSize(window.innerWidth);
  }

  ngOnInit(): void {
    const id = this.activatedRoute.snapshot.paramMap.get('id');
    if (id) {
      this.memberService.getMemberById(id).then((resp) => {
        this.member = resp;
        this.initCrumbs();
      });
      this.user = this.authService.getLoggedInUser();
      this.feedService.getFeedByMember(id).then((res) => {
        this.feed = res.docs;
        this.isExpanded = this.feed.map(() => false);
      });
      this.eventsService.getAcceptedEventsByUser(id).then((res) => {
        this.acceptedEvents = res.docs;
      });
      this.eventsService.getRejectedEventsByUser(id).then((res) => {
        this.rejectedEvents = res.docs;
      });
    }
  }

  viewEvent(id: any): void {
    this.router.navigate(['/admin/single-event/', { id }]);
  }

  toggleExpansion(index: number): void {
    this.isExpanded[index] = !this.isExpanded[index];
  }

  private setScreenSize(width: number): void {
    if (width < 768) {
      this.mediaHeight = 250;
      this.wordCap = 120;
      this.avatarSize = 70;
    } else {
      this.mediaHeight = 360;
      this.wordCap = 250;
      this.avatarSize = 150;
    }
  }

  initCrumbs(): void {
    this.breadcrumbs = [
      {
        title: 'Members',
        route: '/admin/users',
      },
      {
        title: this.member.name,
      },
    ];
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.setScreenSize(event.target.innerWidth);
  }

  toggleText() {
    this.showFullText = !this.showFullText;
  }
  toggleTextPost() {
    this.showFullTextPost = !this.showFullTextPost;
  }

  formatDate(date: any): any {
    const originalDate = new Date(date);
    return this.datePipe.transform(originalDate, 'h.mm a MMM d, y');
  }

  onImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/img/placeholder_image.jpg';
  }

  openEmailInGmail() {
    if(this.user.email !== this.member.email) {
      window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=${this.member.email}`, '_blank');
    }
  }

  callUs(number: any) {
    if ((this.user.phoneNo !== number) && (this.user.mobileNo !== number)){
      window.location.href = `tel:${number}`
    }
  }
}
